module.exports = __webpack_public_path__ + "static/media/ic weather 8.0cc6eb81.png";